import React, { Component } from 'react'
import Container from '../common/application_container'

import { getUser } from '../../actions/session';


class MainReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            User: getUser(),

        }

    }

    componentDidMount() {

    }



    render() {

        return (
            <Container title="Report" icon="fa fa-bars">
                <div className="card card-body border-top-success border-bottom-success">

                </div>
            </Container>
        )
    }
}
export default MainReport